import { Component } from '@angular/core';
import { LoginService } from '../../login.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'login',
  templateUrl: 'login.template.html'
})
export class LoginComponent { 

	username: ''; 
	password: '';

	token;

  	constructor(private app: LoginService, private http: HttpClient, private router: Router) {
  	}

  	login() {
    	this.app.login(this.username, this.password);
    	return false;
  	}


}



// WEBPACK FOOTER //
// ./src/app/views/appviews/login.component.ts